import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { safeLocalStorage } from '@utils/localstorage';

/**
 * Shared auth guard for owner dashboard pages.
 * Runs once per page navigation (not on every layout remount when using getLayout).
 */
export function useOwnerPageGuard() {
	const router = useRouter();
	const token = safeLocalStorage.getItem('token');

	useEffect(() => {
		if (!token) {
			router.push('/dashboard-login');
			return;
		}

		if (token?.user?.blocklisted) {
			router.push('/banned');
		}
	}, [token, router]);

	return token;
}
